import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import {
  LogsItem,
  LogListRequestModel,
  LogsResponseModel,
} from '@/models/logs-page/logs-list.model';
import { clearObj } from '@marfa/bo-utils';

export default class GetLogListRequest extends ApiResourceMethod<LogsResponseModel> {
  public perform(params: LogListRequestModel) {
    const requestData = { ...params };

    return this.performer.requestWithMapper(
      { params: clearObj(requestData) },
      (payload: BaseResponse<LogsItem[]>) => {
        return { data: payload.data, headers: payload.headers };
      },
    );
  }
}
